export class ScholarshipDetail {
    public ID: number;
    public HashCode: string;
    public Scholar_HashCode: string;
    public StandardID: number;
    public MediumID: number;
    public AcademicYearID: number;
    public GrNo: string;
    public StudName: string;
    public ScholarshipTypeID: number;
    public Amount: number;
    public YearID: number;
}